import { ChartData } from '../../../models/IChartData';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ff-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.scss']
})
export class PieChartComponent implements OnInit {

  /**
   * Data to display use the ChartData interface
   * Format: {name: string, value: number}
   * @internal
   */
  @Input() data: ChartData[];

  /**
   * fill elements with a gradient instead of a solid color
   * Default value: true
   * @internal
   */

  @Input() gradient: boolean = true;

  /**
   * show or hide the legend
   * Default value: true
   * @internal
   */

  @Input() showLegend: boolean = true;

  /**
   * show or hide the labels
   * Default value: true
   * @internal
   */
  @Input() showLabels: boolean = true;

  /**
   * should doughnut instead of pie slices
   * Default value: false
   * @internal
   */
  @Input() isDoughnut: boolean = false;

  /**
   * the legend position ['right', 'below']
   * Default value: below
   * @internal
   */
  @Input() legendPosition: string = 'below';

  /**
* Chart width
* Default value: 700
* @internal
*/

  @Input() width: number = 700;

  /**
* Chart height
* Default value: 400
* @internal
*/

  @Input() height: number = 400;
  /**
* Function to execute in the parent component
* @internal
*/

  @Input() select: Function;

  /**
  * Function to execute in the parent component
  * @internal
  */

  @Input() activate: Function;

  /**
  * Function to execute in the parent component
  * @internal
  */

  @Input() deactivate: Function;

  chartSize: number[] = [];

  colorScheme = {
    domain: []
  };
  constructor() { }

  ngOnInit(): void {
    this.chartSize[this.width, this.height];

    this.data.forEach(() => {
      this.random_hex_color_code();
    })
  }

  random_hex_color_code = (): void => {
    const randomColor = Math.floor(Math.random() * 16777215).toString(16);
    this.colorScheme.domain.push('#' + randomColor.slice(0, 6));
  };

  onSelect = (data): void => {
    !!this.select
      ? this.select(data)
      : '';
  }

  onActivate = (data): void => {
    !!this.activate
      ? this.activate(data)
      : '';
  }

  onDeactivate = (data): void => {
    !!this.deactivate
      ? this.deactivate(data)
      : '';
  }
}
